import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";

import api from "../api/axiosClient";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const response = await api.get("/me/");

      setUser(response.data);

      return response.data;
    } catch (error) {
      setUser(null);

      return null;
    }
  }, []);

  useEffect(() => {
    let active = true;

    const initializeAuth = async () => {
      try {
        const response = await api.get("/me/");

        if (active) {
          setUser(response.data);
        }
      } catch (error) {
        if (active) {
          setUser(null);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    initializeAuth();

    return () => {
      active = false;
    };
  }, []);

  const login = async () => {
    return await fetchUser();
  };

  const refreshUser = async () => {
    return await fetchUser();
  };

  const updateUser = (updatedUser) => {
    if (updatedUser) {
      setUser((currentUser) => ({
        ...(currentUser || {}),
        ...updatedUser,
      }));
    }
  };

  const logout = async () => {
    try {
      await api.post("/logout/");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        refreshUser,
        updateUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(
      "useAuth must be used inside an AuthProvider."
    );
  }

  return context;
};
